import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailCard from '../components/DetailCard';
import DetailHeader from '../components/DetailHeader';
import InfoList from '../components/InfoList';
import LoadStatus from '../components/LoadStatus';
import { getReview } from './reviewApi';
import { toStars } from './stars';

const BACK = { backTo: '/admin/feedback', backLabel: '피드백 목록' };

// 별점·피드백 상세 화면. 작성자 정보, 별점, 피드백 전문을 보여준다.
export default function FeedbackDetailPage() {
    const { feedbackId } = useParams();
    const [item, setItem] = useState(null);
    const [error, setError] = useState('');

    // 피드백 상세를 불러온다.
    const load = useCallback(async () => {
        setError('');
        setItem(null);
        try {
            setItem(await getReview(feedbackId));
        } catch (loadError) {
            setError(loadError.message);
        }
    }, [feedbackId]);

    useEffect(() => { load(); }, [load]);

    if (!item) return <><DetailHeader {...BACK} title="피드백" /><LoadStatus error={error} onRetry={load} /></>;

    return (
        <>
            <DetailHeader {...BACK} title={`${item.user_name || '사용자'}님의 피드백`} />
            <DetailCard title="기본 정보">
                <InfoList items={[
                    { label: '사용자', value: item.user_name },
                    { label: '이메일', value: item.user_email },
                    { label: '사용자 ID', value: item.user_id },
                    { label: '작성일', value: item.created_at },
                    { label: '별점', value: <span style={{ color: '#c0842a' }} aria-label={`${item.rating}점`}>{toStars(item.rating)} <span className="muted">({item.rating}점)</span></span> },
                ]} />
            </DetailCard>
            <DetailCard title="피드백 내용">
                {item.feedback ? <p>{item.feedback}</p> : <p className="muted">별점만 남기고 내용은 작성하지 않았습니다.</p>}
            </DetailCard>
        </>
    );
}
